export default "__VITE_ASSET__rf3u9KKn__"